const PROFILEVIEW = {
  cropImage: "Cortar imagem",
  changePassword: "Mudar senha",
  address: "Dirección",
  textValidationAddress: "Verifique se a estrutura do endereço é um exemplo: Calle 84 24 - 78, Bogotá",
  profileUser: "Perfil de usuário",
  name: "Nome",
  enterName: "Digite o nome",
  lastname: "Sobrenome",
  enterLastname: "Insira o último nome",
  company: "Companhia",
  enterCompany: "Digite o nome da empresa",
  department: "Departamento",
  city: "Cidade",
  rol: "Função",
  enterRol: "Digite o nome da função",
  local: "Local",
  update: "Atualizar",
  matchPassword: "As senhas não combinam.",
  user: "Do utilizador",
  EmptyFields: "Faltam campos para preencher",
  updateUser: "Usuário atualizado com sucesso."
};

export default { PROFILEVIEW };
